import React from "react";
import styles from "./Modal.module.scss";

export const ModalTopBar = ({ icon }: { icon: JSX.Element }) => {
  return (
    <div className={styles.TopBar}>
      <h1 className={styles.ModalHeader}>Notice</h1>
      {icon}
    </div>
  );
};
